import { Injectable, inject } from '@angular/core';

import { ON_SPORTS_WEB_INIT } from '@frontend/sports/common/core/feature/app-init';

@Injectable({ providedIn: 'root' })
export class SportsWebLazyBootstrapService {
    private initializers = inject(ON_SPORTS_WEB_INIT);

    private isAlreadyBootstrapped = false;

    async onSportsWebInit(): Promise<void> {
        if (this.isAlreadyBootstrapped) {
            return;
        }

        const promises: Promise<unknown>[] = [];

        for (const initializer of this.initializers) {
            const promise = initializer.onAppInit();

            if (!(promise instanceof Promise)) {
                continue;
            }

            promises.push(promise);
        }

        await Promise.all(promises);

        this.isAlreadyBootstrapped = true;
    }
}
